import { useState, useEffect, useCallback } from 'react';

export interface AutoRefreshConfig {
  enabled: boolean;
  intervalSeconds: number;
}

const DEFAULT_CONFIG: AutoRefreshConfig = {
  enabled: true,
  intervalSeconds: 5,
};

const STORAGE_KEY = 'lens-auto-refresh-config';

export function useAutoRefreshConfig() {
  const [config, setConfig] = useState<AutoRefreshConfig>(DEFAULT_CONFIG);

  // Load config from localStorage on mount
  useEffect(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (stored) {
        const parsed = JSON.parse(stored);
        setConfig({ ...DEFAULT_CONFIG, ...parsed });
      }
    } catch (error) {
      console.warn('Failed to load auto-refresh config from localStorage:', error);
    }
  }, []);

  // Save config to localStorage whenever it changes
  const updateConfig = useCallback((newConfig: Partial<AutoRefreshConfig>) => {
    const updatedConfig = { ...config, ...newConfig };
    setConfig(updatedConfig);
    
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(updatedConfig));
    } catch (error) {
      console.warn('Failed to save auto-refresh config to localStorage:', error);
    }
  }, [config]);

  return {
    config,
    updateConfig,
  };
}